import React from 'react';

// In-page confirmation for Disconnect (destructive). The message comes from
// disconnectMessage(item). Cancel is the default focus.
export default function ConfirmDisconnect({ message, onCancel, onConfirm, busy }) {
  if (!message) return null;
  return (
    <div role="presentation" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
      <div role="alertdialog" aria-modal="true" aria-labelledby="disconnect-title" style={{ background: '#fff', borderRadius: 8, padding: 20, maxWidth: 480 }}>
        <h2 id="disconnect-title" style={{ marginTop: 0, color: '#b91c1c' }}>Disconnect bank?</h2>
        {message.split('\n\n').map((p) => <p key={p}>{p}</p>)}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" autoFocus onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" onClick={onConfirm} disabled={busy}
            style={{ background: '#b91c1c', color: '#fff', border: '1px solid #991b1b', borderRadius: 4, padding: '4px 12px' }}>Disconnect</button>
        </div>
      </div>
    </div>
  );
}
